import Balance from "./balance.component";

export default Balance;
